import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { useMount } from 'ahooks';
import { observable } from 'mobx';
import { copyToClipboard } from '@src/utils/common-util';
import message from '@src/components/common-message';
import { getLocales } from '@src/global-locales/get-page-locales-data';

class RedeemModalStore extends BaseModalStore {
  name = 'redeem-modal';

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable modalTitle = getLocales('gift.cdkCode_modal_title');

  @observable cdKey = '';

  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.clearStyle();
  };

  copyCdKey = async () => {
    try {
      await copyToClipboard(this.cdKey);
      message.success(getLocales('gift.copy_success_tips_text'));
    } catch (error) {
      message.fail(getLocales('gift.copy_error_tips_text'));
    }
  };

  fetchCdKey = async () => {
    try {
      const { isDownloadStage } = this.$globalStore;
      const { getCodeInSubscribe, getCodeInDownLoad } = this.$ztService;
      const cdKeyRequest = isDownloadStage ? getCodeInDownLoad : getCodeInSubscribe;
      const res = await cdKeyRequest();
      this.cdKey = res.code;
    } catch (error) {
      error?.message && message.fail(error?.message);
    }
  };

  use() {
    super.use();

    useMount(() => {
      this.fetchCdKey();
    });
  }
}

export default RedeemModalStore;
